// extracted by mini-css-extract-plugin
module.exports = {"text":"SatPicMeta_text_24Nu5"};